"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.makeTableStyles = void 0;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var makeTableStyles = function makeTableStyles(_ref) {
  var primitives = _ref.primitives,
      tokens = _ref.tokens;
  return {
    MuiTable: {
      styleOverrides: {
        root: {
          "&.DhigTable--verticalAlignment--center tbody tr td": {
            verticalAlign: "middle"
          },
          "&.DhigTable--verticalAlignment--top tbody tr td": {
            verticalAlign: "top"
          },
          "&.DhigTable--zebra": {
            "& tbody tr:nth-of-type(odd)": {
              backgroundColor: tokens.colors["background-panel"].color
            },
            "& tbody tr:hover": {
              backgroundColor: tokens.colors["row-hover-zebra"].rgb
            }
          },
          "& tbody tr:last-child": {
            borderBottom: "none"
          },
          "&.DhigTable--loud": {
            "& tr.DhigTableRow--enableInteractions": {
              position: "relative",
              borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["row-divider"].rgb),
              "&:hover": _objectSpread(_objectSpread({}, tokens.gradients["row-hover-loud-reverse"]), {}, {
                backgroundAttachment: "fixed"
              }),
              "&:active": _objectSpread(_objectSpread({}, tokens.gradients["row-pressed-loud-reverse"]), {}, {
                backgroundAttachment: "fixed"
              })
            },
            "&.DhigTableRow--activated.Mui-selected": _objectSpread({}, tokens.gradients["row-activated-loud-reverse"]),
            "& tr.Mui-selected": {
              backgroundColor: tokens.colors["row-selected-loud"].rgb,
              backgroundAttachment: "fixed"
            },
            "& tr.Mui-selected.DhigTableRow--enableInteractions": {
              "&:hover": _objectSpread(_objectSpread({}, tokens.gradients["row-selected-hover-loud"]), {}, {
                backgroundAttachment: "fixed"
              })
            }
          },
          "& tr.DhigTableRow--highlighted": {
            backgroundColor: tokens.colors["row-highlighted"].rgb
          },
          "& tr.DhigTableRow--highlighted.DhigTableRow--enableInteractions": {
            "& tr.Mui-selected.DhigTableRow--highlighted": {
              backgroundColor: tokens.colors["row-highlighted-selected-loud"].rgb
            }
          },
          "&.DhigTable--bordered": {
            background: tokens.colors["fill-elevation-0"].rgb,
            boxShadow: tokens.effects["container-1"].boxShadow,
            borderRadius: primitives.borderRadii.medium,
            "& tbody tr td:last-of-type": {
              padding: "".concat(primitives.spacings[4], " ").concat(primitives.spacings[3], " ").concat(primitives.spacings[4], " 0"),
              width: primitives.spacings[6],
              textAlign: "right",
              "& svg": {
                fontSize: primitives.fontSizes[5]
              }
            },
            '& tbody tr td[class*="MuiTableCell-sizeSmall"]:last-of-type': {
              width: primitives.spacings[5],
              "& svg": {
                fontSize: primitives.fontSizes[4]
              }
            }
          }
        }
      }
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          position: "relative",
          border: 0,
          borderBottom: "".concat(primitives.borderWidths.medium, " solid ").concat(tokens.colors["row-divider"].rgb),
          "&.DhigTableRow--enableInteractions": {
            cursor: "pointer",
            "&:hover": {
              backgroundColor: tokens.colors["row-hover"].rgb,
              '& .DhigTableCell--isEditing [class*="MuiInputBase-root"].Mui-disabled': {
                background: tokens.colors["fade-gradient-transparent"].rgb
              }
            },
            "&:active": {
              backgroundColor: tokens.colors["row-pressed"].rgb
            }
          },
          "&.DhigTableRow--highlighted": {
            backgroundColor: tokens.colors["row-highlighted"].rgb
          },
          "&.DhigTableRow--highlighted.DhigTableRow--enableInteractions": {
            "&:hover": {
              backgroundColor: tokens.colors["row-highlighted-hover"].rgb
            },
            "&:active": {
              backgroundColor: tokens.colors["row-highlighted-pressed"].rgb
            }
          },
          "&.Mui-selected": {
            backgroundColor: tokens.colors["row-selected"].rgb,
            "&:hover": {
              backgroundColor: tokens.colors["row-selected"].rgb
            }
          },
          "&.Mui-selected.DhigTableRow--enableInteractions": {
            "&:hover": {
              backgroundColor: tokens.colors["row-selected-hover"].rgb
            },
            "&:active": {
              backgroundColor: tokens.colors["row-selected-pressed"].rgb
            }
          },
          "&.Mui-selected.DhigTableRow--highlighted": {
            backgroundColor: tokens.colors["row-selected-highlighted"].rgb
          },
          "&.Mui-selected.DhigTableRow--highlighted.DhigTableRow--enableInteractions": {
            "&:hover": {
              backgroundColor: tokens.colors["row-selected-highlighted-hover"].rgb
            },
            "&:active": {
              backgroundColor: tokens.colors["row-selected-highlighted-hover"].rgb
            }
          },
          "&.DhigTableRow--activated": _objectSpread(_objectSpread({}, tokens.gradients["row-activated-loud-reverse"]), {}, {
            backgroundAttachment: "fixed",
            pointerEvents: "none",
            cursor: "default",
            "& td:last-of-type": {
              position: "relative",
              "&:after": {
                content: "''",
                background: tokens.colors["ink-on-background"].rgb,
                position: "absolute",
                right: primitives.spacings["0"],
                top: primitives.spacings["0"],
                bottom: primitives.spacings["0"],
                width: primitives.borderWidths["large"],
                display: "inline-block"
              }
            },
            '& > [class*="MuiTableCell-root"] > [class*="MuiCheckbox-root"], & > [class*="MuiTableCell-root"] > [class*="MuiFormControlLabel-root"]': {
              pointerEvents: "auto",
              cursor: "pointer"
            }
          }),
          "&.DhigTableRow--activated.Mui-highlighted": _objectSpread({}, tokens.gradients["row-highlighted-activated-loud-reverse"]),
          "&.DhigTableRow--activated.Mui-selected": _objectSpread({}, tokens.gradients["row-selected-activated-loud-reverse"]),
          "&.DhigTableRow--activated.Mui-selected.DhigTableRow--highlighted": _objectSpread({}, tokens.gradients["row-highlighted-selected-activated-loud-reverse"])
        },
        head: {
          "&:hover": {
            backgroundColor: primitives.colors.detail.transparent
          }
        }
      }
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          lineHeight: primitives.spacings[5],
          fontSize: primitives.fontSizes[3],
          borderBottom: "none",
          color: tokens.colors["ink-on-background"].rgb,
          "&.DhigTableCell--isEditing": {
            padding: 0,
            '& .Mui-error[class*="MuiInput-underline"]:hover:not(.Mui-disabled):before': _objectSpread({}, tokens.effects["field-error"]),
            '& [class*="MuiFormHelperText-root"]': {
              marginBottom: primitives.spacings[1],
              "&.Mui-error": {
                display: "flex",
                alignItems: "center"
              }
            },
            '& [class*="MuiInputBase-root"]': {
              boxShadow: "none",
              background: tokens.colors["field-fill"].rgb,
              padding: primitives.spacings[4],
              margin: "0 2px 1px 0",
              "& input": {
                color: tokens.colors["ink-on-background"].color,
                padding: 0,
                fontSize: primitives.fontSizes[3],
                lineHeight: primitives.lineHeights.tight,
                height: "19px"
              },
              "& input:active": {
                boxShadow: "none"
              },
              "&.Mui-error": {
                margin: 0
              }
            },
            '& [class*="MuiInput-underline"]:before': {
              borderBottom: "none",
              top: primitives.spacings["0"],
              bottom: "-1px"
            },
            '& [class*="MuiInput-underline"]:after': {
              display: "none"
            },
            '& [class*="MuiInput-underline"]:hover:not(.Mui-disabled):before': {
              boxShadow: tokens.effects["hover-halo-inwards"].boxShadow
            }
          },
          '&.DhigTableCell--isEditing[class*="MuiTableCell-alignRight"]': {
            '& [class*="MuiInputBase-input"]': {
              textAlign: "right"
            },
            '& [class*="MuiFormHelperText-root"]': {
              "&.Mui-error": {
                alignSelf: "end"
              }
            }
          },
          '&[class*="MuiTableCell-sizeSmall"]': {
            fontSize: primitives.fontSizes[2],
            '& [class*="MuiTableSortLabel-root"]': {
              fontSize: primitives.fontSizes[2]
            }
          },
          '&[class*="MuiTableCell-head"]': {
            whiteSpace: "nowrap",
            lineHeight: primitives.spacings[5]
          }
        },
        paddingCheckbox: {
          "&.DhigTableCell--checkbox": {
            padding: primitives.spacings["0"],
            '& label[class*="MuiFormControlLabel-root"]': {
              margin: primitives.spacings["0"],
              position: "relative",
              zIndex: 2,
              '& [class*="MuiCheckbox-root"]': {
                margin: primitives.spacings["4"]
              },
              '& [class*="MuiFormControlLabel-label"]': {
                display: "none"
              }
            }
          }
        }
      }
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          "& tr": {
            "&:hover": {
              background: primitives.colors.detail.transparent
            },
            '& th.DhigTableHead--cell[class*="MuiTableCell-sizeSmall"]': {
              padding: "".concat(primitives.spacings[3], " ").concat(primitives.spacings[4])
            },
            "& th.DhigTableHead--cell--sort": {
              position: "relative",
              border: 0,
              "&::before": {
                display: "block",
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                content: '""'
              },
              "&:hover": {
                backgroundColor: tokens.colors["hover-fill-subtle"].rgb
              },
              "&:active": {
                backgroundColor: tokens.colors["pressed-fill-subtle"].rgb
              }
            },
            "& th.DhigTableHead--cell--enableSelect": {
              padding: primitives.spacings["0"],
              "& label.DhigTableHead--checkbox": {
                margin: primitives.spacings["0"],
                '& [class*="MuiCheckbox-root"]': {
                  margin: primitives.spacings["4"]
                },
                '& [class*="MuiFormControlLabel-label"]': {
                  display: "none"
                }
              }
            },
            "& th.DhigTableHead--cell": {
              padding: "18px ".concat(primitives.spacings["4"]),
              '& [class*="MuiTableSortLabel-root"]': {
                cursor: "default"
              }
            }
          }
        }
      }
    },
    MuiTableSortLabel: {
      styleOverrides: {
        root: _objectSpread(_objectSpread({}, tokens.typography["headline-smaller"]), {}, {
          color: tokens.colors["ink-on-background"].rgb,
          "&:hover, :focus": {
            color: tokens.colors["ink-on-background"].rgb
          },
          "&.Mui-active": {
            color: tokens.colors["ink-on-background"].rgb
          },
          "& svg[class*='MuiSvgIcon-root']": {
            fontSize: primitives.fontSizes[4]
          }
        })
      }
    }
  };
};

exports.makeTableStyles = makeTableStyles;